import { render, staticRenderFns } from "./FirstNationAssociationsViewer.vue?vue&type=template&id=56a35fa0&scoped=true&lang=pug"
import script from "./FirstNationAssociationsViewer.vue?vue&type=script&lang=js"
export * from "./FirstNationAssociationsViewer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56a35fa0",
  null
  
)

export default component.exports